import { Heading, Medium } from '@energiebespaarders/symbols/helpers';

const Expectations: React.FC = () => (
  <>
    <Heading heading="h4">Hoe werkt het?</Heading>
    <ol>
      <li>
        <Medium>Woninggegevens invullen</Medium>
        <br />
        Je vult eerst wat gegevens in over je wensen en je woning.
      </li>
      <li>
        <Medium>Mogelijkheden verkennen</Medium>
        <br />
        Je ziet meteen de mogelijke oplossingen, inclusief besparingen en terugverdientijden.
      </li>
      <li>
        <Medium>Offertes van betrouwbare installateurs ontvangen</Medium>
        <br />
        Je vraagt offertes aan bij installateurs die we zorgvuldig hebben geselecteerd.
      </li>
    </ol>
  </>
);

export default Expectations;
